// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MZMW0 {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.Cx3Ch {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.u311W {
    display: flex;
    flex-direction: row;
    margin: 2px;
    flex: 1;
    justify-content: center;
}

.Y3OcI {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.SeIjR {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
}

.cahM7 {
    width: 44px;
    height: 44px;
    background-color: black;
    border-radius: 22px;
    pointer-events: auto;
}

.LVt1C {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
}

.LVt1C:hover {
    opacity: 0.8;
}

.LVt1C:active {
    opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/containers/gameboard/GameBoard.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".container {\n    flex: 1;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.board {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    margin: 2px;\n    flex: 1;\n    justify-content: center;\n}\n\n.column {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.settingsButtonContainer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n}\n\n.settingsButtonWrapper {\n    width: 44px;\n    height: 44px;\n    background-color: black;\n    border-radius: 22px;\n    pointer-events: auto;\n}\n\n.settingsButton {\n    width: 44px;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 20;\n    cursor: pointer;\n    border: none;\n    background: none;\n    padding: 0;\n}\n\n.settingsButton:hover {\n    opacity: 0.8;\n}\n\n.settingsButton:active {\n    opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MZMW0`,
	"board": `Cx3Ch`,
	"row": `u311W`,
	"column": `Y3OcI`,
	"settingsButtonContainer": `SeIjR`,
	"settingsButtonWrapper": `cahM7`,
	"settingsButton": `LVt1C`
};
export default ___CSS_LOADER_EXPORT___;
